import { z } from 'zod';
export const PaymentMethodType = z.enum(['card', 'ach']);
// Client confirms a SetupIntent via the Payment Element, then sends the
// SetupIntent id back so the server can attach + persist the resulting method.
export const SavePaymentMethodSchema = z.object({
    setupIntentId: z.string().min(1),
    setAsDefault: z.boolean().optional().default(false),
});
